import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  title: {
    ...dFlex('space-between', 'center'),
    width: '100%',
    padding: '0 16px',
  },
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '16px',
    textAlign: 'center',
    marginTop: 16,
  },
  inputContainer: {
    ...dFlex('unset', 'flex-start'),
    flexDirection: 'column',
    gap: 4,
    width: '100%',
  },
  totals: {
    ...dFlex('unset', 'center'),
    flexDirection: 'column',
    gap: 8,
  },
  row: {
    ...dFlex('space-between', 'center'),
    width: '100%',
  },
  tooltipValue: {
    ...dFlex('unset', 'center'),
    gap: '4px',
  },
}));

export default useStyles;
